<template>
    <div class="page">
        <div class="modal">
            <h1
                class="heading"
                v-if="heading">{{ heading }}</h1>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            default: null,
            required: false,
            type: String
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.heading {
    color: #1c74a5;
    font-size: 20px;
    font-weight: 300;
    margin: 0 0 20px;
    text-align: center;
}

.modal {
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    margin: 100px auto;
    max-width: 500px;
    padding: var(--site-padding);
    width: 100%;

    @media (--mq-medium-min) {
        padding: 40px;
    }
}

.page {
    margin: 0 auto;
    max-width: var(--site-container-width);
    padding: var(--site-padding);
    width: 100%;
}
</style>
